import React, { Component } from 'react';
import Fade from './Fade.js';

import {CreateSenderChooseSocialNetwork} from './CreateSenderChooseSocialNetwork';
import {SenderVarsPage} from './SenderVarsPage';
import {SenderVarsVkPage} from './SenderVarsVkPage';
import {SenderRedMessagePage} from './SenderRedMessagePage';
import axios from 'axios';
import Cookies from 'universal-cookie';
import {Loader} from './Loader.js';
import { LineProgressBar } from '@frogress/line';
import { HorizontalLine } from './HorizontalLine.js';
import LeftArrowIcon from './LeftArrowIcon';
import HelpBlockIcon from './HelpBlockIcon';



export class SenderPage extends React.Component {

    state = {
        socialNetwork :'tg',
        senderVarsVkPage : !true,
        chooseSocialNetworkPage : true,
        senderVarsPage : !true,
        senderRedMessagePage : !true,
        chosenAlias: '',
        text: '',
        photo: null,
        selectedFile: null,
        mailing_name: '',
        isLoading : false,
        stage : '33_tg',
        showProgressNum : true,
        infoBlock: '',
        successMsg : '',
        showSuccessMsg : false,
        stageNum: 3,
        currentStageNum: 1,
        progressBarHeight: 23
    }
    constructor(props) {
        super(props);
        //console.log(this.props.data)
        this.changeSocialNetwork = this.changeSocialNetwork.bind(this)
        this.handleClickFirstStage = this.handleClickFirstStage.bind(this)
        this.handleClickSecondStage = this.handleClickSecondStage.bind(this)
        this.chooseTgSenderAlias = this.chooseTgSenderAlias.bind(this)
        this.updateText = this.updateText.bind(this)
        this.handleInputChangePhoto = this.handleInputChangePhoto.bind(this)
        this.updateMailingName = this.updateMailingName.bind(this)
        
        this.doSave = this.doSave.bind(this)
        this.goFurther = this.goFurther.bind(this)
        this.goBack = this.goBack.bind(this)
    }

    componentDidMount() {
        if (document.body.clientWidth >= 1600) {
            this.setState({
                progressBarHeight : 27
            })
        }
        

    }

    stageList = {
        '1_tg' : 'chooseSocialNetworkPage',
        '2_tg' : 'senderVarsPage',
        '3_tg' : 'senderRedMessagePage',
        '1_vk' : 'chooseSocialNetworkPage',
        '2_vk' : 'senderVarsVkPage',
        '3_vk' : 'senderRedMessagePage',
    }
    
    stageListInfoBlock = {}

    stageNumTg = 3
    stageNumVk = 3

    goBack(e) {
        e.preventDefault()
        
         if (true) {

            
            var stageNow = this.state.currentStageNum
            if (stageNow == 1 ) {
                return;
            }   
            var stageNext = stageNow - 1 + '_'+this.state.socialNetwork
           
            //alert( stageNext )
                   
            this.setState((prevState) => {
                    return  {
                        ...prevState,
                        showProgressNum:true,
                        currentStageNum : stageNow - 1,
                        stageNum : this.stageNumTg,
                        [this.stageList[stageNow+'_'+this.state.socialNetwork]] : false,
                        
                    
                    };
            }, () =>  {
                
            }) 
            //alert(this.stageList[stageNext])
            setTimeout(() => {
                   
                        this.setState((prevState) => {
                            return  {
                                ...prevState,
                                stageNum :this.stageNumTg ,
                                [this.stageList[stageNext]] : true,
                                stage :  stageNext,
                                infoBlock: [this.stageListInfoBlock[stageNext]], 
                                stageCurrentNum :  stageNow - 1
                            };
                        }, () =>  {
                            
                        })
                    
                
    
            }, 460)
         }
         
      
        
    }

    goFurther() {
        
    //alert(123)
        if (true) {

            
            var stageNow = this.state.currentStageNum
            var stageNext = stageNow + 1 + '_'+this.state.socialNetwork
           
            //alert( stageNext )
                   
            this.setState((prevState) => {
                    return  {
                        ...prevState,
                        currentStageNum : stageNow + 1,
                        stageNum : this.stageNumTg,
                        [this.stageList[stageNow+'_'+this.state.socialNetwork]] : false,
                        
                    
                    };
            }, () =>  {
                
            }) 
            //alert(this.stageList[stageNext])
            setTimeout(() => {
                    if (stageNow + 1 == this.stageNumTg ){
                        this.setState((prevState) => {
                            return  {
                                ...prevState,
                                
                                showProgressNum: false,
                                [this.stageList[stageNext]] : true,
                                infoBlock: [this.stageListInfoBlock[stageNext]], 
                                currentStageNum :  stageNow + 1
                            
                            };
                        }, () =>  {
                            
                        })
                    }
                    else {
                        this.setState((prevState) => {
                            return  {
                                ...prevState,
                                stageNum :this.stageNumTg ,
                                [this.stageList[stageNext]] : true,
                                stage :  stageNext,
                                infoBlock: [this.stageListInfoBlock[stageNext]], 
                                stageCurrentNum :  stageNow + 1
                            };
                        }, () =>  {
                            
                        })
                    }
                
    
            }, 460)

        }
        
       

        
        
        
    }
    
    chooseTgSenderAlias(e, alias, count) {
        //e.preventDefault()
        if (count == 0) {
            this.doShowErrorMsg("В этом чат-боте еще никто не получал лид-магнит, поэтому в данный момент рассылку создать не получится :( Для тестирования можете сами воспользоваться чат-ботом для получения подарка.")
            return;
        }
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   chosenAlias : alias
                   
               
               };
       }, () =>  {
           
       })
    }
    
    handleClickFirstStage(e) {
        
        
            e.preventDefault()
            //alert(1)
            this.setState((prevState) => {
                return  {
                       ...prevState,
                       chooseSocialNetworkPage : false
                       
                   
                   };
           }, () =>  {
               
           })
    
           if (this.state.socialNetwork == 'tg') {
    
                setTimeout(() => {
                
                    this.setState((prevState) => {
                        return  {
                            ...prevState,
                            senderVarsPage : true
                            
                        
                        };
                }, () =>  {
                    
                })
    
                }, 460)
    
                
    
           }
           else {
            setTimeout(() => {
                
                this.setState((prevState) => {
                    return  {
                        ...prevState,
                        senderVarsVkPage : true
                        
                    
                    };
            }, () =>  {
                
            })
    
            }, 460)
    
        
        }
        
    } 
    
    handleClickSecondStage(e) {

            e.preventDefault()
            //alert(1)
            if (!Boolean(this.state.chosenAlias)) {
                alert('Выберите сообщество для рассылки')
                return;
            }
            this.goFurther()
    
                
    

    }

    changeSocialNetwork(a) {
        
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   socialNetwork : a
                   
               
               };
       }, () =>  {
           
       })

    } 

    updateText(e) {
        const updatedInputValue = e.target.value;
        
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    text : updatedInputValue,
                    
                
                };
        }, () =>  {
            
        })
    }

    updateMailingName(e){
        const updatedInputValue = e.target.value;
        
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    mailing_name : updatedInputValue,
                    
                
                };
        }, () =>  {
            
        })
    }

    handleInputChangePhoto(event){
        this.setState({
            selectedFile: event.target.files[0],
          }, () => {
            const data = new FormData() 
            data.append('file', this.state.selectedFile)
            console.warn(this.state.selectedFile);
            
            const cookies = new Cookies();
            axios.post(process.env.REACT_APP_BACKEND_SERVER + '/UploadImg/',
                 data, {
                    headers: {
                        'Authorization': 'Bearer '+cookies.get('tgsubs_token')
                    }     // receive two parameter endpoint url ,form data 
            })
            .then(res => { // then print response status
                 
                this.setState({
                    photo: res.data.link
                  }, () => {})
            })
          })
    }



    doShowErrorMsg ( msg) {
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   errorMsg : msg,
                   showErrorMsg : true
               };
       }, () =>  {
           
       })
        setTimeout(() => { 
          
            this.setState((prevState) => {
                return  {
                       ...prevState,
                       errorMsg : null,
                       showErrorMsg : false
                   };
           }, () =>  {
               
           })

        }, 8000)
      }
    
      doShowSuccessMsg ( msg) {
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   successMsg : msg,
                   showSuccessMsg : true
               };
       }, () =>  {
           
       })
        setTimeout(() => { 
          
            this.setState((prevState) => {
                return  {
                       ...prevState,
                       successMsg : null,
                       showSuccessMsg : false
                   };
           }, () =>  {
               
           })

        }, 2000)
      }



    doSave(e) {

        const cookies = new Cookies();
        
        
        if (!Boolean(this.state.text) &&  !Boolean(this.state.photo)) {
            alert("Нужно добавить либо текст, либо фотографию")
            return;
        }

        if (!Boolean(this.state.mailing_name)) {
            alert("Нужно добавить название для рассылки, чтобы вы потом могли вспомнить что отправляли своим клиентам.")
            return;
        }

        if (this.state.socialNetwork == 'tg') {
            

            axios.post(process.env.REACT_APP_BACKEND_SERVER + '/CreateTgSender/',
             {
                 text : this.state.text,
                 photo: this.state.photo ,
                 name: this.state.mailing_name,
                 alias: this.state.chosenAlias
             }, {
                headers: {
                    'Authorization': 'Bearer '+cookies.get('tgsubs_token')
                }     // receive two parameter endpoint url ,form data 
            })
            .then(res => { // then print response status
                
                if (res.data.status == 'ok') {
                    window.location.href = '/mailing#tg'
                }
                else {
                    this.doShowErrorMsg(res.data.text)
                }

            })


        }
        else {
            axios.post(process.env.REACT_APP_BACKEND_SERVER + '/CreateVkSender/',
             {
                 text : this.state.text,
                 photo: this.state.photo ,
                 name: this.state.mailing_name,
                 alias: this.state.chosenAlias
             }, {
                headers: {
                    'Authorization': 'Bearer '+cookies.get('tgsubs_token')
                }     // receive two parameter endpoint url ,form data 
            })
            .then(res => { // then print response status
                
                if (res.data.status == 'ok') {
                    window.location.href = '/mailing#vk'
                }
                else{
                    this.doShowErrorMsg(res.data.text)
                    
                }

            })
        }
        


    }

    render() {
        return (
            <div>
                <Fade show={this.state.showErrorMsg}>
                <div className='errorMessage'>
                  Ошибка: {this.state.errorMsg}
                </div>
              </Fade>
              <Fade show={this.state.showSuccessMsg}>
                <div className='successMessage'>
                   {this.state.successMsg}
                </div>
              </Fade>
                <Loader loader={this.state.isLoading} />
                <div className='createPage'>
                        <div className="createPageTitle">
                            <h1 style={{marginBottom:"2px"}}>
                                 { this.props.title ? this.props.title : "Создать рассылку"}</h1>
                            <HorizontalLine />
                        </div>
                        <div className='createWidgetMainBlock'>
                            <div className="createWidgetMainBlock__progressBar">
                                <div className="createWidgetMainBlock__progressBar_label">
                                    Этап:
                                </div>
                                
                               <LineProgressBar
                                   transition={{ easing: 'linear' }}
                                label={(value) => <div>  <span className={this.state.showProgressNum ? "progressBar_etaps" : "progressBar_etaps hidden"}><span className='progressBar_etaps_blue'>{Math.round( value * this.state.stageNum / 100)}</span>   /   {this.state.stageNum} </span> </div>} 
                                percent={Math.round(this.state.currentStageNum / this.state.stageNum * 100)}
                                rounded={36}
                                height={'2.4em'}
                                progressColor="linear-gradient(90deg, #31D0E1 3.43%, #0868F5 86.29%);"
                                containerColor="#FFF" />`
                            </div>
                            
                          <div onClick={this.goBack} className="createWidgetMainBlock_back">
                            < LeftArrowIcon /> Назад
                            </div> 
                
                    
                    
                <Fade show={this.state.chooseSocialNetworkPage}>
                    <CreateSenderChooseSocialNetwork
                    title={"Создать рассылку"}
                    goFurther={this.goFurther} 
                    ChooseSocialNetwork={this.handleClickFirstStage} 
                    changeSocialNetwork={this.changeSocialNetwork}
                    socialNetwork={this.state.socialNetwork} />

                </Fade>

                <Fade show={this.state.senderVarsPage}>
                    <SenderVarsPage 
                    handleClickSecondStage={this.handleClickSecondStage} 
                    chooseTgSenderAlias={this.chooseTgSenderAlias}
                    chosenAlias={this.state.chosenAlias}/>

                </Fade>


                <Fade show={this.state.senderVarsVkPage}>
                    <SenderVarsVkPage 
                    handleClickSecondStage={this.handleClickSecondStage} 
                    chooseTgSenderAlias={this.chooseTgSenderAlias}
                    chosenAlias={this.state.chosenAlias}/>

                </Fade>


                <Fade show={this.state.senderRedMessagePage}>
                    
                    <SenderRedMessagePage
                    doSave={this.doSave}
                    updateMailingName={this.updateMailingName}
                    mailing_name={this.state.mailing_name} 
                    updateText={this.updateText} 
                    text={this.state.text}
                    photo={this.state.photo}
                    handleInputChangePhoto={this.handleInputChangePhoto} />

                </Fade>
                </div>
                </div>            
            </div>
                 
        )
    }
    
}